export enum ProgressBarActionsEnum {
  SET_PROGRESS_PERCENTAGE = '@progressBar/SET_PROGRESS_PERCENTAGE',
}

export type ProgressBarState = { percentage: number };
